import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { timeout } from "rxjs/operators";

@Injectable({
  providedIn: 'root'
})
export class DownloadService {
  constructor(private http: HttpClient) {}

  downloadContent(params: HttpParams): Observable<any> {
    const url = `${environment.url.api}/files/contents`
    return this.http.get(url, {
        responseType: 'blob',
        params: params,
        headers: new HttpHeaders({
          'Accept': 'application/octet-stream'
        })
      });
  }

}